module.exports = __webpack_public_path__ + "img/wenzhangfengmian1.93ce415e.png";